import React from 'react';
import { Box, Typography } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';

const AccessDenied = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: { xs: '50vh', md: '60vh' },
        textAlign: 'center',
        px: { xs: 2, sm: 3 },
      }}
    >
      <BlockIcon sx={{ fontSize: { xs: 48, sm: 56, md: 64 }, color: 'error.main', mb: { xs: 1.5, md: 2 } }} />
      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
          color: 'text.primary',
          mb: 1,
          fontSize: { xs: '1.25rem', sm: '1.375rem', md: '1.5rem' },
        }}
      >
        Access Denied – Supervisor Only
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          fontSize: { xs: '0.875rem', md: '0.9375rem' },
        }}
      >
        You don't have permission to view this page.
      </Typography>
    </Box>
  );
};

export default AccessDenied;
